export default __webpack_public_path__ + "static/web-design-course@2x-068969e3cefcbefec58ad03a7ce82736.png";